module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dataset":"Dataset"},"ja":{"dataset":"データセット"}}')
  delete Component.options._Ctor
}
